export interface IErrorState {
  readonly hasError: boolean
  readonly errorMessage: string
  clear(): void
  set(message: string): void
}

export class ErrorState implements IErrorState {
  constructor(private message: string = '') {}

  get hasError(): boolean {
    return this.message.length > 0
  }

  get errorMessage(): string {
    return this.message
  }

  clear(): void {
    this.message = ''
  }

  set(message: string): void {
    this.message = message
  }
}
